import {FC, useState, createContext, useContext, Dispatch, SetStateAction} from 'react'

import {WithChildren} from '../../../../_metronic/helpers'

type InvestorContextProps = {
  templateTypesFilter: boolean
  setTemplateTypesFilter: Dispatch<SetStateAction<boolean>>
  selectedTemplateTypeFilter: string
  setSelectedTemplateTypeFilter: Dispatch<SetStateAction<string>>
  documentsSubmissionFilter: boolean
  setDocumentsSubmissionFilter: Dispatch<SetStateAction<boolean>>
  selectedDocumentStatusFilter: string
  setSelectedDocumentStatusFilter:Dispatch<SetStateAction<string>>
  selectedDocumentSignatureStatusFilter:string
  setSelectedDoucmentSignatureStatusFilter:Dispatch<SetStateAction<string>>
}

const initInvestorContextPropsState = {
  templateTypesFilter: false,
  setTemplateTypesFilter: () => {},
  selectedTemplateTypeFilter: '',
  setSelectedTemplateTypeFilter: () => {},
  documentsSubmissionFilter: false,
  setDocumentsSubmissionFilter: () => {},
  selectedDocumentStatusFilter: '',
  setSelectedDocumentStatusFilter:() => {},
  selectedDocumentSignatureStatusFilter:'',
  setSelectedDoucmentSignatureStatusFilter:() => {},
}

const DigitalSigningContext = createContext<InvestorContextProps>(initInvestorContextPropsState)

const useDigitalSigning = () => {
  return useContext(DigitalSigningContext)
}

const DigitalSigningProvider: FC<WithChildren> = ({children}) => {
  const [templateTypesFilter, setTemplateTypesFilter] = useState(false)
  const [selectedTemplateTypeFilter, setSelectedTemplateTypeFilter] = useState<string>('')
  const [documentsSubmissionFilter, setDocumentsSubmissionFilter] = useState(false)
  const [selectedDocumentStatusFilter, setSelectedDocumentStatusFilter] = useState<string>('')
  const [selectedDocumentSignatureStatusFilter, setSelectedDoucmentSignatureStatusFilter] = useState<string>('')

  return (
    <DigitalSigningContext.Provider
      value={{
        templateTypesFilter,
        setTemplateTypesFilter,
        selectedTemplateTypeFilter,
        setSelectedTemplateTypeFilter,
        documentsSubmissionFilter,
        setDocumentsSubmissionFilter,
        selectedDocumentStatusFilter, 
        setSelectedDocumentStatusFilter,
        selectedDocumentSignatureStatusFilter, 
        setSelectedDoucmentSignatureStatusFilter
      }}
    >
      {children}
    </DigitalSigningContext.Provider>
  )
}

export {DigitalSigningProvider, useDigitalSigning}
